module.exports = "/assets/data/2af099544ad5fad17659c56ca6e13e83-SL3.data.json";